
import React, { useState } from "react";
import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import { useArmyboard } from "../hooks/useArmyboard";
import { getArmyIcon } from "../util/getArmyIcon";
import {
  FaTrophy,
  FaGamepad,
  FaChartLine,
  FaListOl,
  FaHome,
  FaBars,
  FaUsers,
  FaScroll,
  FaCog,
  FaNewspaper
} from "react-icons/fa";

const Armyboard = () => {
  const idleague = 1;
  const { factions } = useArmyboard(idleague);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Armies");

  const menuItems = [
    { name: "WH40k League", icon: FaHome, link: "/wh40k" },
    { name: "AOS League", icon: FaHome, link: "/" },
    { name: "Leaderboard", icon: FaTrophy, link: "/leaderboard1" },
    { name: "Matches", icon: FaGamepad, link: "/matches" },
    { name: "Players", icon: FaUsers },
    { name: "Rules", icon: FaScroll },
    { name: "Settings", icon: FaCog }
  ];

  const armies = Array.isArray(factions)
    ? factions.flatMap(f => f.armies || [])
    : [];

  const renderArmyTable = () => (
    <div className="bg-gray-800 rounded-lg shadow-lg p-6">
      <h2 className="text-2xl font-bold mb-4 text-center">Army Board</h2>
      <div className="overflow-x-auto">
        <table className="w-full table-fixed">
          <thead>
            <tr className="bg-gray-700">
              <th className="w-12 px-4 py-2 text-center">Pos</th>
              <th className="w-32 px-4 py-2 text-left">Army</th>
              <th className="w-12 px-4 py-2 text-center">G</th>
              <th className="w-12 px-4 py-2 text-center">W</th>
              <th className="w-12 px-4 py-2 text-center">L</th>
              <th className="w-12 px-4 py-2 text-center">D</th>
              <th className="w-12 px-4 py-2 text-center">PS</th>
              <th className="w-12 px-4 py-2 text-center">PC</th>
              <th className="w-12 px-4 py-2 text-center">TP</th>
            </tr>
          </thead>
          <tbody>
            {armies.map((army, index) => {
              const ArmyIcon = getArmyIcon(army.army_name);
              return (
                <tr key={index} className="hover:bg-gray-700 transition-colors duration-200">
                  <td className="px-4 py-2 text-center">{index + 1}</td>
                  <td className="px-4 py-2 flex items-center space-x-2">
                    <ArmyIcon className="w-6 h-6 text-white" />
                    <span>{army.army_name}</span>
                  </td>
                  <td className="px-4 py-2 text-center">{army.played}</td>
                  <td className="px-4 py-2 text-center text-green-500">{army.won}</td>
                  <td className="px-4 py-2 text-center text-red-500">{army.lost}</td>
                  <td className="px-4 py-2 text-center">{army.drawn}</td>
                  <td className="px-4 py-2 text-center">{army.score}</td>
                  <td className="px-4 py-2 text-center">{army.counterscore}</td>
                  <td className="px-4 py-2 text-center font-semibold">{army.points}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderFactionTables = () => {
    const factionSummary = Array.isArray(factions)
      ? factions.map(f => {
          const totalPoints = f.armies?.reduce((sum, a) => sum + (a.points || 0), 0) || 0;
          return { name: f.faction, points: totalPoints };
        }).sort((a, b) => b.points - a.points)
      : [];

    return (
      <div className="space-y-8">
        <div className="bg-gray-800 rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-bold mb-4 text-center">Faction Ranking</h2>
          <table className="w-full table-fixed">
            <thead>
              <tr className="bg-gray-700">
                <th className="w-12 px-4 py-2 text-center">Pos</th>
                <th className="px-4 py-2 text-left">Faction</th>
                <th className="w-12 px-4 py-2 text-center">G</th>
                <th className="w-12 px-4 py-2 text-center">W</th>
                <th className="w-12 px-4 py-2 text-center">L</th>
                <th className="w-12 px-4 py-2 text-center">D</th>
                <th className="w-12 px-4 py-2 text-center">PS</th>
                <th className="w-12 px-4 py-2 text-center">PC</th>
                <th className="w-12 px-4 py-2 text-center">TP</th>               
              </tr>
            </thead>
            <tbody>
              {factionSummary.map((faction, index) => (
                <tr key={index} className="hover:bg-gray-700 transition-colors duration-200">
                  <td className="px-4 py-2 text-center">{index + 1}</td>
                  <td className="px-4 py-2">{faction.name}</td>
                  <td className="px-4 py-2 text-center">{faction.played}</td>
                  <td className="px-4 py-2 text-center text-green-500">{faction.won}</td>
                  <td className="px-4 py-2 text-center text-red-500">{faction.lost}</td>
                  <td className="px-4 py-2 text-center">{faction.drawn}</td>
                  <td className="px-4 py-2 text-center">{faction.score}</td>
                  <td className="px-4 py-2 text-center">{faction.counterscore}</td>
                  <td className="px-4 py-2 text-center font-semibold">{faction.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {Array.isArray(factions) && factions.map((faction, index) => (
          <div key={index} className="bg-gray-800 rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold mb-4 text-center">{faction.faction}</h2>
            <div className="overflow-x-auto">
              <table className="w-full table-fixed">
                <thead>
                  <tr className="bg-gray-700">
                    <th className="w-12 px-4 py-2 text-center">Pos</th>
                    <th className="w-32 px-4 py-2 text-left">Army</th>
                    <th className="w-12 px-4 py-2 text-center">G</th>
                    <th className="w-12 px-4 py-2 text-center">W</th>
                    <th className="w-12 px-4 py-2 text-center">L</th>
                    <th className="w-12 px-4 py-2 text-center">D</th>
                    <th className="w-12 px-4 py-2 text-center">PS</th>
                    <th className="w-12 px-4 py-2 text-center">PC</th>
                    <th className="w-12 px-4 py-2 text-center">TP</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(faction.armies) && faction.armies.map((army, idx) => {
                    const ArmyIcon = getArmyIcon(army.army_name);
                    return (
                      <tr key={idx} className="hover:bg-gray-700 transition-colors duration-200">
                        <td className="px-4 py-2 text-center">{idx + 1}</td>
                        <td className="px-4 py-2 flex items-center space-x-2">
                          <ArmyIcon className="w-6 h-6 text-white" />
                          <span>{army.army_name}</span>
                        </td>
                        <td className="px-4 py-2 text-center">{army.played}</td>
                        <td className="px-4 py-2 text-center text-green-500">{army.won}</td>
                        <td className="px-4 py-2 text-center text-red-500">{army.lost}</td>
                        <td className="px-4 py-2 text-center">{army.drawn}</td>
                        <td className="px-4 py-2 text-center">{army.score}</td>
                        <td className="px-4 py-2 text-center">{army.counterscore}</td>
                        <td className="px-4 py-2 text-center font-semibold">{army.points}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      <header className="bg-gray-800 p-4 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Logo" className="w-10 h-10 rounded-full" />
            <h1 className="text-2xl font-bold">Clasificación de Ejércitos</h1>
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden text-white">
            <FaBars size={24} />
          </button>
          <nav className={`lg:flex space-x-4 ${menuOpen ? "block" : "hidden"}`}>
            {menuItems.map((item, index) => (
              <a key={index} href={item.link} className="flex items-center space-x-1 text-gray-300 hover:text-white transition duration-200">
                <item.icon className="text-sm" />
                <span>{item.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </header>

      <div className="flex justify-center mt-4 space-x-4">
        {["Armies", "Factions"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded ${activeTab === tab ? 'bg-white text-black font-bold' : 'bg-gray-700 text-white'}`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="flex-grow p-8">
        {activeTab === "Armies" ? renderArmyTable() : renderFactionTables()}
      </div>
    </div>
  );
};

export default Armyboard;
